<template>
  <div class="page_setting">
    <div class="page-header">
      <div class="page-header-index-wide">
        <a-breadcrumb class="breadcrumb">
          <a-breadcrumb-item>
            <router-link :to="{ path: '/' }">首页</router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            <span>设置</span>
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            <span>基本配置</span>
          </a-breadcrumb-item>
        </a-breadcrumb>
        <div class="detail">
          <div class="main" >
            <div class="row">
              <h1 class="title">基本配置</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container" :style="{ flexWrap: device === 'mobile' ? 'wrap' : 'nowarp'}">
      <a-menu
        class="p-t-12"
        :style="{
          width: device === 'mobile' ? '100%' : '256px',
          minHeight: device === 'mobile' ? '0' : '80vh'
        }"
        :default-selected-keys="_key" :mode="device === 'mobile' ? 'horizontal' : 'vertical'" @click="handleClick">
        <a-menu-item key="1" v-if="can('batteryseries')">电池系列</a-menu-item>
        <a-menu-item key="2" v-if="can('batteryvoltage')">电池电压</a-menu-item>
        <a-menu-item key="3" v-if="can('batterycapacity')">电池容量</a-menu-item>
      </a-menu>
      <div style="height:100%;" :style="{width: `calc(100% - ${device === 'mobile' ? '0px' : '256px'})`}">
        <div style="height:100%;padding: 20px 24px;" v-if="key === '1' && can('batteryseries')">
          <ak-model-card model="series" title="电池系列" :perPage="20" tableSize="small"/>
        </div>
        <div style="height:100%;padding: 20px 24px;" v-if="key === '2' && can('batteryvoltage')">
          <ak-model-card model="voltage" title="电池电压" :perPage="20" tableSize="small"/>
        </div>
        <div style="height:100%;padding: 20px 24px;" v-if="key === '3' && can('batterycapacity')">
          <ak-model-card model="capacity" title="电池容量" :perPage="20" tableSize="small"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      settingList: ['batteryseries', 'batteryvoltage', 'batterycapacity'],
      lang: localStorage.lang,
      upLoading: false,
      confirmLoading: false,
      key: '1'
    }
  },
  computed: {
    _key () {
      return [((this.settingList.findIndex(s => this.can(s))) + 1).toString()]
    }
  },
  mounted () {
    this.key = ((this.settingList.findIndex(s => this.can(s))) + 1).toString()
    this.init()
  },
  methods: {
    // 初始化
    async init () {
    },
    // 点击切换
    handleClick (e) {
      this.key = e.key
      this.init()
    }
  }
}
</script>

<style scoped lang="scss">

.page-header {
  background: #fff;
  padding: 16px 32px 0;
  border-bottom: 1px solid #e8e8e8;
  margin: -24px -24px 24px -24px;
  .breadcrumb {
    margin-bottom: 16px;
  }
  .detail {
    display: flex;
    /*margin-bottom: 16px;*/
    .avatar {
      flex: 0 1 72px;
      margin: 0 24px 8px 0;
      & > span {
        border-radius: 72px;
        display: block;
        width: 72px;
        height: 72px;
      }
    }
    .main {
      width: 100%;
      flex: 0 1 auto;
      .row {
        display: flex;
        width: 100%;
        .avatar {
          margin-bottom: 16px;
        }
      }
      .title {
        font-size: 20px;
        font-weight: 500;
        font-size: 20px;
        line-height: 28px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        margin-bottom: 16px;
        flex: auto;
      }
      .logo {
        width: 28px;
        height: 28px;
        border-radius: 4px;
        margin-right: 16px;
      }
      .content,
      .headerContent {
        flex: auto;
        color: rgba(0, 0, 0, 0.45);
        line-height: 22px;
        .link {
          margin-top: 16px;
          line-height: 24px;
          a {
            font-size: 14px;
            margin-right: 32px;
          }
        }
      }
      .extra {
        flex: 0 1 auto;
        margin-left: 88px;
        min-width: 242px;
        text-align: right;
      }
      .action {
        margin-left: 56px;
        min-width: 266px;
        flex: 0 1 auto;
        text-align: right;
        &:empty {
          display: none;
        }
      }
    }
  }
}
.mobile .page-header {
  .main {
    .row {
      flex-wrap: wrap;
      .avatar {
        flex: 0 1 25%;
        margin: 0 2% 8px 0;
      }
      .content,
      .headerContent {
        flex: 0 1 70%;
        .link {
          margin-top: 16px;
          line-height: 24px;
          a {
            font-size: 14px;
            margin-right: 10px;
          }
        }
      }
      .extra {
        flex: 1 1 auto;
        margin-left: 0;
        min-width: 0;
        text-align: right;
      }
      .action {
        margin-left: unset;
        min-width: 266px;
        flex: 0 1 auto;
        text-align: left;
        margin-bottom: 12px;
        &:empty {
          display: none;
        }
      }
    }
  }
}
.container {
  width: 100%;
  background: #ffffff;
  display: flex;
  align-items: stretch;
  .text-primary {
    color: #202224;
  }
  .text-black {
    color: #363B45;
  }
  .text-gray {
    color: #808690;
  }
  .ant-btn {
    width: 54px !important;
    height: 32px !important;
    padding: 0 !important;
  }
  .setting-time-input {
    width: 75px;
    height: 32px;
    background: #FFFFFF;
    border: 1px solid #DBDDE1;
    border-radius: 6px;
  }
  .ant-upload {
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
